import React, { FC } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import DateField from 'components/QuickenControls/DateField';

import { isUnacceptedScheduledTxn, isPendingTxn, isC2RTransaction } from 'data/transactions/utils';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface PosedOnFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  noDateOnBankPending: any;
  editClass: string;
  hoverClass: string;
  currEditFieldName: string;
  enableAutoFocus: boolean;
  showColor: boolean;
  bankPendingClass: string;
  callbacks: CallbacksType;
}

const PosedOnField: FC<PosedOnFieldProps> = ({
  attributes,
  forceStatic,
  editable,
  SHOW_ALL,
  txn,
  noDateOnBankPending,
  editClass,
  hoverClass,
  currEditFieldName,
  enableAutoFocus,
  showColor,
  bankPendingClass,
  callbacks,
}) => {
  const { classes, theme } = useStyles();
  const isPending = (isPendingTxn(txn) && noDateOnBankPending) && !isUnacceptedScheduledTxn(txn);
  const cname = classNames(classes.regItem, editClass, !isPending && hoverClass, 'protectWidthDate');
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={cname}
    >
      {SHOW_ALL && (
        <DateField
          disableKeyboardInput={false}
          fieldId="postedOn"
          editable={!forceStatic && editable && currEditFieldName === 'postedOn'}
          value={txn.postedOn}
          onChange={(e) => callbacks.handleChange?.(e, 'postedOn')}
          // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
          fontSize={theme.mixins?.register.fontSize.default}
          autoFocus={enableAutoFocus}
          clickable={!forceStatic ? 'true' : null}
          className={classNames(classes.dateField, ...(isPending && showColor ? [classes.pending] : []), bankPendingClass, c2RTxnClass)}
          changeDateOnKeyDown
        />
      )}
    </RegListItem>
  );
};

export default PosedOnField;
